import { isPlatformBrowser } from '@angular/common';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private toastr: ToastrService,
    private auth: AuthService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let request = req;

    if (this.router.url.includes('panel')) {
      // let token = null;

      // if (localStorage.getItem('token')) {
      //   if (isPlatformBrowser(this.platformId)) {
      //     token = localStorage.getItem('token');
      //   }
      // }
      // const cloned = req.clone({
      //   headers: req.headers.set('Authorization', 'Bearer ' + token),
      // });

      // return next.handle(cloned).pipe(
      //   catchError((err: HttpErrorResponse) => {
      //     if (err.status === 404) {
      //       this.router.navigateByUrl('/not-available');
      //     }

      //     if (err.status === 401) {
      //       this.auth.logout();
      //     }

      //     if (err.status === 500 || err.status === 0) {
      //       this.router.navigateByUrl('internal-error');
      //     }

      //     return throwError(err);
      //   })
      // );
    }
    // request = req.clone({
    //   setHeaders: {
    //     'X-API-KEY': environment.api_key,
    //     'X-API-KEY-LATINO': environment.api_key_latino,
    //   },
    // });

    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 404) {
          this.router.navigateByUrl('/not-available');
        }

        if (err.status === 401) {
          // this.auth.logout();
        }

        if (err.status === 500 || err.status === 0) {
          this.router.navigateByUrl('internal-error');
        }

        return throwError(err);
      })
    );
  }
}
